// extracted by mini-css-extract-plugin
export default {"view-or-edit-offer-btn":"style_view-or-edit-offer-btn__+5sRi","viewOrEditOfferBtn":"style_view-or-edit-offer-btn__+5sRi"};